import Cookies from 'js-cookie'
import {
  fetchNlLocalePackStatus,
  provisionNlLocalePack,
  fetchNlLocalePackRun
} from '@/api/leoNlLocalePack'

const BUILTIN = new Set(['en', 'zh-Hant'])
const DISMISS_KEY = 'leo_nl_locale_pack_dismiss'

export function frontendLangToLeoLocale (lang) {
  if (!lang) return 'en'
  const t = String(lang).trim().toLowerCase()
  if (t === 'en') return 'en'
  if (t === 'tw' || t === 'zh' || t.startsWith('zh')) return 'zh-Hant'
  if (t === 'ja') return 'ja'
  if (t === 'ko') return 'ko'
  if (t === 'th') return 'th'
  return t
}

export function isBuiltinNlLocale (locale) {
  return BUILTIN.has(locale)
}

export async function getNlLocalePackStatus (lang) {
  const locale = frontendLangToLeoLocale(lang)
  try {
    const res = await fetchNlLocalePackStatus(locale)
    if (res && res.code === 200 && res.data) {
      return { locale, ...res.data }
    }
  } catch (e) {
    if (isBuiltinNlLocale(locale)) {
      return { locale, status: 'ACTIVE', ready: true, builtin: true }
    }
  }
  return { locale, status: 'UNKNOWN', ready: isBuiltinNlLocale(locale), builtin: isBuiltinNlLocale(locale) }
}

export function shouldPromptProvision (status) {
  if (!status || status.ready || status.inProgress) return false
  if (isBuiltinNlLocale(status.locale)) return false
  const dismissed = sessionStorage.getItem(DISMISS_KEY + ':' + status.locale)
  return status.status === 'NOT_REQUESTED' && !dismissed
}

export function dismissProvisionPrompt (locale) {
  sessionStorage.setItem(DISMISS_KEY + ':' + locale, '1')
}

export async function ensureNlLocalePack (lang, { dryRun = false, onProgress } = {}) {
  const locale = frontendLangToLeoLocale(lang)
  const st = await getNlLocalePackStatus(lang)
  if (st.ready || isBuiltinNlLocale(locale)) {
    return st
  }
  if (st.inProgress && st.runUid) {
    return pollNlLocalePackRun(st.runUid, onProgress)
  }
  const res = await provisionNlLocalePack(locale, { dryRun, locale }, 'ui-lang-' + locale)
  if (res && res.code === 200 && res.data) {
    if (res.data.runUid) {
      return pollNlLocalePackRun(res.data.runUid, onProgress)
    }
    return res.data
  }
  throw new Error((res && res.msg) || 'provision_failed')
}

export async function pollNlLocalePackRun (runUid, onProgress, maxAttempts = 120) {
  for (let i = 0; i < maxAttempts; i++) {
    const res = await fetchNlLocalePackRun(runUid)
    const row = res && res.data
    if (onProgress && row) {
      onProgress(row)
    }
    const st = row && row.status
    if (st === 'SUCCESS' || st === 'FAILED') {
      const summary = row.resultSummary || {}
      return {
        locale: summary.locale,
        status: summary.status || (st === 'SUCCESS' ? 'ACTIVE' : 'FAILED'),
        ready: summary.status === 'ACTIVE',
        runUid,
        summary
      }
    }
    await sleep(2000)
  }
  throw new Error('poll_timeout')
}

function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function persistLeoLocaleCookie (lang) {
  const locale = frontendLangToLeoLocale(lang)
  Cookies.set('leoNlLocale', locale, { expires: 365 })
  return locale
}

export function readLeoLocaleCookie () {
  return Cookies.get('leoNlLocale') || frontendLangToLeoLocale(Cookies.get('language'))
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/leoNlLocalePack.js